import { render, staticRenderFns } from "./ZhuYuanBaoGaoRecord.vue?vue&type=template&id=1c164173&scoped=true"
import script from "./ZhuYuanBaoGaoRecord.vue?vue&type=script&lang=js"
export * from "./ZhuYuanBaoGaoRecord.vue?vue&type=script&lang=js"
import style0 from "./ZhuYuanBaoGaoRecord.vue?vue&type=style&index=0&id=1c164173&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c164173",
  null
  
)

export default component.exports